import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, CardContent } from '@mui/material';
import { useGetAnswersQuery } from '../features/api/rest/apiAnswersSlice';
import AnswerCard from './AnswerCard';
import Spinner from './Spinner';
import Error from './Error';

function AnswersResults({ questionId }) {
  const { ean } = useParams();
  const [sorted, setSorted] = useState(false);
  const [sortedAnswers, setSortedAnswers] = useState([]);

  const { answers, isLoading, isFetching, isError } = useGetAnswersQuery(
    { ean, Q: questionId, mine: false },
    {
      selectFromResult: ({ data }) => ({
        answers: data?.results,
      }),
    }
  );

  const sortAnswers = () => {
    const sortingAnswers = answers.slice().sort((a, b) => new Date(b.created) - new Date(a.created));
    setSortedAnswers(sortingAnswers);
    setSorted(true);
  };

  if (isLoading || isFetching) return <Spinner />;
  if (isError) return <Error />;

  return (
    <Box>
      <CardContent sx={{ p: 0 }}>
        {!sorted && answers && sortAnswers()}
        {sortedAnswers.map((answer) => (
          <AnswerCard key={answer.id} answerId={answer.id} answer={answer.body} owner={answer.owner} created={answer.created} questionId={questionId} totScore={answer.tot_score} />
        ))}
      </CardContent>
    </Box>
  );
}

AnswersResults.propTypes = {
  questionId: PropTypes.number.isRequired,
};

export default AnswersResults;
